module.exports = __webpack_public_path__ + "static/plataforma-8913242211a39cc8b681bd83b66e3c2f.png";